export default __webpack_public_path__ + "static/media/bus.be05e3c7.svg";